import { BookOpen, CircleHelp, Info, LogOut, Settings, UsersRound } from 'lucide-react';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { UserAvatar } from '../components/UserAvatar';
import { primaryNavigation } from './navigation';

const utilityNavigation = [
  { to: '/social', label: 'Social', icon: UsersRound },
  { to: '/settings', label: 'Ajustes', icon: Settings },
  { to: '/help', label: 'Ajuda', icon: CircleHelp },
  { to: '/about', label: 'Sobre', icon: Info }
];

const errorMessage = (error: unknown) => error instanceof Error
  ? error.message
  : 'Não foi possível sair. Tente novamente.';

export const DesktopSidebar = ({
  firstName,
  level,
  openSession,
  elapsed,
  onSignOut
}: {
  firstName: string;
  level: number;
  openSession: { id: string; status: string } | undefined;
  elapsed: string;
  onSignOut: () => Promise<void>;
}) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string>();

  const signOut = async () => {
    if (busy) return;
    setBusy(true);
    setError(undefined);
    try {
      await onSignOut();
    } catch (signOutError) {
      setError(errorMessage(signOutError));
    } finally {
      setBusy(false);
    }
  };

  return (
    <aside className="desktop-sidebar" aria-label="Menu lateral">
      <NavLink to="/profile" className="desktop-sidebar__profile" aria-label="Abrir perfil no menu lateral">
        <UserAvatar />
        <span className="desktop-sidebar__identity">
          <span>{firstName}</span>
          <small>Level {level}</small>
        </span>
      </NavLink>

      <div className="desktop-sidebar__brand" aria-label="LEITOUR">
        <BookOpen aria-hidden="true" />
        <span>LEITOUR</span>
      </div>

      <nav className="desktop-sidebar__nav" aria-label="Navegação principal desktop">
        {primaryNavigation.map(({ to, label, icon: Icon, end, central }) => (
          <NavLink
            key={to}
            to={to}
            {...(end ? { end: true } : {})}
            className={({ isActive }) => `desktop-sidebar__link ${central ? 'desktop-sidebar__link--add' : ''} ${isActive ? 'is-active' : ''}`}
          >
            <Icon aria-hidden="true" />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>

      {openSession && (
        <NavLink to={`/session/${openSession.id}`} className="desktop-sidebar__session">
          <span className="desktop-sidebar__session-label">
            <span className="pulse-dot" />
            {openSession.status === 'paused' ? 'Sessão pausada' : 'Lendo agora'}
          </span>
          <strong>{elapsed}</strong>
        </NavLink>
      )}

      <div className="desktop-sidebar__footer">
        <nav className="desktop-sidebar__nav" aria-label="Utilidades desktop">
          {utilityNavigation.map(({ to, label, icon: Icon }) => (
            <NavLink key={to} to={to} className={({ isActive }) => `desktop-sidebar__link ${isActive ? 'is-active' : ''}`}>
              <Icon aria-hidden="true" />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <button type="button" className="desktop-sidebar__link desktop-sidebar__signout" disabled={busy} onClick={() => void signOut()}>
          <LogOut aria-hidden="true" />
          <span>{busy ? 'Saindo…' : 'Sair'}</span>
        </button>
        {error && <p className="desktop-sidebar__error" role="alert">{error}</p>}
      </div>
    </aside>
  );
};
